export const createFormSchema = {
  type: 'VerticalLayout',
  elements: [
    { 
      type: 'Control', 
      scope: '#/properties/CUSIP', 
      label: 'CUSIP',   
    },
  ],
}; 